import {
	apiLineChartAbonnement,
	apiLineChartResilitation,
	apiUpdateDashboard,
} from '@/features/profile/api/profile.api';
import {
	TKPI,
	TLineGraph,
	TReportingBodyRequest,
	TTableauGlobal,
	TTableauGlobalResilie,
	TTableauSecteur,
} from '@/features/profile/types/profile.types';
import { store } from '@/store';
import {
	isDashboardLoading,
	isLineChartAbonnementLoading,
	isLineChartResiliationLoading,
	updateKPI,
	updateLineGraphAbonnement,
	updateLineGraphResiliation,
	updateTableauGlobal,
	updateTableauGlobalResilie,
	updateTableauSecteur,
} from '@/store/reducers/dashboard/dashboard.action';
import { selectDashboardKPI } from '@/store/reducers/dashboard/dashboard.selector';
import { ToastGeneric } from '@/utils/toast';
import { Icon, InlineIcon } from '@iconify/react';
import {
	Button,
	FormControl,
	MenuItem,
	Select,
	TextField,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as yup from 'yup';
import DropdownMenu from '../DropdownMenu/dropdown-menu';
import { ExportProgressLoader } from '../Loader/ExportProgress';
import './dashboard-filter.style.scss';

type DashboardFilterProps = ConnectedProps<typeof connector>;

type DashboardProps = {
	setPerimetreSelected?: React.Dispatch<React.SetStateAction<string>>;
	setPositionAbonnementSelected?: React.Dispatch<
		React.SetStateAction<string>
	>;
};
const DashboardFilter: React.FC<DashboardFilterProps & DashboardProps> = ({
	kpiDatas,
	setPerimetreSelected,
	setPositionAbonnementSelected,
}) => {
	const dispatch = store.dispatch;

	const [date_abonnement_debut, setDate_abonnement_debut] =
		React.useState<Dayjs | null>(dayjs('1956-01-01'));
	const [date_abonnement_fin, setDate_abonnement_fin] =
		React.useState<Dayjs | null>(dayjs().subtract(0, 'year'));
	const [date_resiliation_debut, setDate_resiliation_debut] =
		React.useState<Dayjs | null>(dayjs('1956-01-01'));
	const [date_resiliation_fin, setDate_resiliation_fin] =
		React.useState<Dayjs | null>(dayjs().subtract(0, 'year'));
	const [kpiAmountFirstCall, setKpiAmountFirstCall] =
		React.useState<number>(0);

	const [anneeMinResiliation, setAnneeMinResiliation] = useState(0);
	const [anneeMaxResiliation, setAnneeMaxResiliation] = useState(0);
	const [anneeMinAbonnement, setAnneeMinAbonnement] = useState(0);
	const [anneeMaxAbonnement, setAnneeMaxAbonnement] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	const validationSchema = yup.object({
		periode_abonnement_trimestre_fin: yup
			.string()
			.test({
				name: 'max_over_min_trimestre',
				message:
					' le trimestre de fin doit être strictement supérieur au trimestre de début pour la même année',
				test: function (value, ctx) {
					let result = false;
					let annee_debut = parseInt(
						ctx.parent.periode_abonnement_annee_debut
					);
					let annee_fin = parseInt(
						ctx.parent.periode_abonnement_annee_fin
					);
					if (value) {
						if (annee_fin === annee_debut) {
							let numeroTrimestreDebutAbonnement =
								ctx.parent.periode_abonnement_trimestre_debut.substr(
									-1
								);
							let numeroTrimestreFinAbonnement = value.substr(-1);
							return (
								numeroTrimestreFinAbonnement >
								numeroTrimestreDebutAbonnement
							);
						} else {
							result = true;
						}
					}

					return result;
				},
			})
			.test({
				name: 'no_all_admitted',
				message: ' Les deux trimestres doivent être sélectionnés ',
				test: function (value, ctx) {
					let result = false;
					if (value) {
						if (
							value.toLowerCase() === 'all' &&
							ctx.parent.periode_abonnement_trimestre_debut.toLowerCase() !==
								'all'
						) {
							result = false;
						} else if (
							value.toLowerCase() !== 'all' &&
							ctx.parent.periode_abonnement_trimestre_debut.toLowerCase() ===
								'all'
						) {
							result = false;
						} else {
							result = true;
						}
					}

					return result;
				},
			}),
		periode_abonnement_annee_fin: yup.string().test({
			name: 'max_over_min_annee',
			message: " l'année de fin doit être supérieure à l'année de début",
			test: function (value, ctx) {
				let result = false;
				if (value) {
					let annee_fin = parseInt(value);
					let annee_debut = parseInt(
						ctx.parent.periode_abonnement_annee_debut
					);
					if (annee_fin >= annee_debut) {
						result = true;
					} else {
						result = false;
					}
				}

				return result;
			},
		}),
		periode_resiliation_trimestre_fin: yup
			.string()
			.test({
				name: 'max_over_min_trimestre',
				message:
					' le trimestre de fin doit être strictement supérieur au trimestre de début pour la même année',
				test: function (value, ctx) {
					let result = false;
					let annee_debut = parseInt(
						ctx.parent.periode_resiliation_annee_debut
					);
					let annee_fin = parseInt(
						ctx.parent.periode_resiliation_annee_fin
					);
					if (value) {
						if (annee_fin === annee_debut) {
							let numeroTrimestreDebutAbonnement =
								ctx.parent.periode_resiliation_trimestre_debut.substr(
									-1
								);
							let numeroTrimestreFinAbonnement = value.substr(-1);
							return (
								numeroTrimestreFinAbonnement >
								numeroTrimestreDebutAbonnement
							);
						} else {
							result = true;
						}
					}

					return result;
				},
			})
			.test({
				name: 'no_all_admitted',
				message: ' Les deux trimestres doivent être sélectionnés ',
				test: function (value, ctx) {
					let result = false;
					if (value) {
						if (
							value.toLowerCase() === 'all' &&
							ctx.parent.periode_resiliation_trimestre_debut.toLowerCase() !==
								'all'
						) {
							result = false;
						} else if (
							value.toLowerCase() !== 'all' &&
							ctx.parent.periode_resiliation_trimestre_debut.toLowerCase() ===
								'all'
						) {
							result = false;
						} else {
							result = true;
						}
					}

					return result;
				},
			}),
		periode_resiliation_annee_fin: yup.string().test({
			name: 'max_over_min_annee',
			message: " l'année de fin doit être supérieure à l'année de début",
			test: function (value, ctx) {
				let result = false;
				if (value) {
					let annee_fin = parseInt(value);
					let annee_debut = parseInt(
						ctx.parent.periode_resiliation_annee_debut
					);
					if (annee_fin >= annee_debut) {
						result = true;
					} else {
						result = false;
					}
				}

				return result;
			},
		}),
	});

	useEffect(() => {
		//   console.log({kpiDatas});
		if (kpiAmountFirstCall === 1) {
			let dateMinResil =
				kpiDatas.min_resil && kpiDatas.min_resil > 1900
					? kpiDatas.min_resil
					: 1900;
			let dateMinAbon =
				kpiDatas.min_abon && kpiDatas.min_abon > 1900
					? kpiDatas.min_abon
					: 1900;

			setDate_abonnement_debut(dayjs().year(dateMinAbon));
			setDate_abonnement_fin(dayjs().year(kpiDatas.max_abon));
			setDate_resiliation_debut(dayjs().year(dateMinResil));
			setDate_resiliation_fin(dayjs().year(kpiDatas.max_resil));

			setAnneeMaxAbonnement(kpiDatas.max_abon);
			setAnneeMinAbonnement(dateMinAbon);
			setAnneeMinResiliation(dateMinResil);
			setAnneeMaxResiliation(kpiDatas.max_resil);
		}
	}, [kpiDatas, kpiAmountFirstCall]);

	useEffect(() => {
		if (kpiAmountFirstCall === 1) {
			console.log('test date_resiliation_fin', date_resiliation_fin);
			setKpiAmountFirstCall(2);
			// formik.submitForm();
		}
	}, [date_resiliation_fin]);

	const formik = useFormik({
		initialValues: {
			perimetre_abonne: 'All',
			position_abonne: 'All',
			periode_abonnement_trimestre_debut: 'All',
			periode_abonnement_annee_debut: dayjs('1956-01-01')
				.get('year')
				.toString(),
			periode_abonnement_trimestre_fin: 'All',
			periode_abonnement_annee_fin: dayjs()
				.subtract(0, 'year')
				.get('year')
				.toString(),
			periode_resiliation_trimestre_debut: 'All',
			periode_resiliation_annee_debut: dayjs('1956-01-01')
				.get('year')
				.toString(),
			periode_resiliation_trimestre_fin: 'All',
			periode_resiliation_annee_fin: dayjs()
				.subtract(0, 'year')
				.get('year')
				.toString(),
		},
		validationSchema: validationSchema,

		onSubmit: value => {
			let dataToSend: TReportingBodyRequest = {
				date_debut:
					(value.periode_resiliation_trimestre_debut.toLowerCase() ===
					'all'
						? 'T1'
						: value.periode_resiliation_trimestre_debut) +
					'-' +
					date_resiliation_debut?.get('year'), //anneeDebutResiliation,
				date_fin:
					(value.periode_resiliation_trimestre_fin.toLowerCase() ===
					'all'
						? 'T4'
						: value.periode_resiliation_trimestre_fin) +
					'-' +
					date_resiliation_fin?.get('year'), // anneeFinResiliation,

				// date_debut: ((value.periode_resiliation_trimestre_debut.toLowerCase() === 'all') ? 'T1' : value.periode_resiliation_trimestre_debut)  + '-' + value.periode_resiliation_annee_debut,
				// date_fin: ((value.periode_resiliation_trimestre_fin.toLowerCase() === 'all') ? 'T4' : value.periode_resiliation_trimestre_fin)  + '-' + value.periode_resiliation_annee_fin,

				// debut_abon: ((value.periode_abonnement_trimestre_debut.toLowerCase() === 'all') ? 'T1' : value.periode_abonnement_trimestre_debut)  + '-' + value.periode_abonnement_annee_debut,
				// fin_abon: ((value.periode_abonnement_trimestre_fin.toLowerCase() === 'all') ? 'T4' : value.periode_abonnement_trimestre_fin) + '-' + value.periode_abonnement_annee_fin,

				debut_abon:
					(value.periode_abonnement_trimestre_debut.toLowerCase() ===
					'all'
						? 'T1'
						: value.periode_abonnement_trimestre_debut) +
					'-' +
					date_abonnement_debut?.get('year'),
				fin_abon:
					(value.periode_abonnement_trimestre_fin.toLowerCase() ===
					'all'
						? 'T4'
						: value.periode_abonnement_trimestre_fin) +
					'-' +
					date_abonnement_fin?.get('year'),

				perimetre:
					value.perimetre_abonne.toLowerCase() === 'all'
						? null
						: value.perimetre_abonne,
				position:
					value.position_abonne.toLowerCase() === 'all'
						? null
						: value.position_abonne,
			};

			console.log(dataToSend);

			getTableDataAndKPIAmount(dataToSend);
			getDataLineGraphResiliation(dataToSend);
			getDataLineGraphAbonnement(dataToSend);
		},
	});

	const cancelSearch = () => {
		// formik.initialValues;

		formik.setValues({
			perimetre_abonne: 'All',
			position_abonne: 'All',
			periode_abonnement_trimestre_debut: 'All',
			periode_abonnement_annee_debut: dayjs('1956-01-01')
				.get('year')
				.toString(),
			periode_abonnement_trimestre_fin: 'All',
			periode_abonnement_annee_fin: dayjs('2022-01-01')
				.get('year')
				.toString(),
			periode_resiliation_trimestre_debut: 'All',
			periode_resiliation_annee_debut: dayjs('1956-01-01')
				.get('year')
				.toString(),
			periode_resiliation_trimestre_fin: 'All',
			periode_resiliation_annee_fin: dayjs()
				.subtract(0, 'year')
				.get('year')
				.toString(),
		});

		formik.submitForm();

		// getTableDataAndKPIAmount(dataToSend);
		// getDataLineGraphResiliation(dataToSend);
		// getDataLineGraphAbonnement(dataToSend);
	};

	/** KPI amount and table */
	const getTableDataAndKPIAmount = (dataSend: TReportingBodyRequest) => {
		dispatch(isDashboardLoading(true));
		apiUpdateDashboard(dataSend)
			.then((response: any) => {
				console.log(response);
				dispatch(isDashboardLoading(false));
				if (response.error) {
					ToastGeneric(response.message, 'error', 3000).fire();
				} else {
					let kpi_amount: TKPI = response.data?.stats as TKPI;
					let tableauSecteur: TTableauSecteur | null = response.data
						?.secteur as TTableauSecteur | null;
					let tableauGlobal: TTableauGlobal | null = response.data
						?.global as TTableauGlobal | null;
					let tableauGlobalResilie: TTableauGlobalResilie | null =
						response.data
							?.global_resilie as TTableauGlobalResilie | null;

					if (kpiAmountFirstCall === 0) {
						console.log(
							' kpiAmountFirstCall return fct ',
							kpiAmountFirstCall
						);

						setKpiAmountFirstCall(1);
						// dispatch(updateKPI(kpi_amount));
						// return;
					}

					console.log(' tableauGlobal ', tableauGlobal);
					console.log(' tableauGlobalResilie ', tableauGlobalResilie);

					let finalTableauGlobal: any = [];
					let finalTableauGlobalResilie: any = [];
					let finalTableauSecteur: any = [];

					if (tableauGlobal) {
						tableauGlobal.forEach(item => {
							let obj = {
								date: item.date,
								total_restant: item.total_restant,
								asc_encaisse: item.asc_encaisse,
								// asc_rembourse: item.asc_rembourse,
								// asc_restant: item.asc_restant,
								total_abonne: item.total_abonne,
								// total_resilie: item.total_resilie,
								actions: () => {
									//   setIsActif(true);
									return (
										<DropdownMenu
											row={item}
											isActifOrNot={true}
											setIsLoading={setIsLoading}
											isSendBackOrNot={false}
										/>
									);
								},
							};

							finalTableauGlobal.push(obj);
						});
					}

					if (tableauGlobalResilie) {
						tableauGlobalResilie.forEach(item => {
							let obj = {
								date: item.date,
								total_restant: item.total_restant,
								// asc_encaisse: item.asc_encaisse,
								asc_rembourse: item.asc_rembourse,
								// asc_restant: item.asc_restant,
								// total_abonne: item.total_abonne,
								total_resilie: item.total_resilie,
								actions: () => {
									//   setIsActif(true);
									return (
										<DropdownMenu
											row={item}
											isActifOrNot={true}
											setIsLoading={setIsLoading}
											isSendBackOrNot={true}
										/>
									);
								},
							};

							finalTableauGlobalResilie.push(obj);
						});
					}

					if (tableauSecteur) {
						tableauSecteur.forEach(item => {
							let obj = {
								secteur: item.secteur,
								// asc_encaisse: item.asc_encaisse,
								asc_rembourse: item.asc_rembourse,
								// asc_restant: item.asc_restant,
								total_abonne: item.total_abonne,
								actions: () => {
									//   setIsActif(false);
									return (
										<DropdownMenu
											row={item}
											isActifOrNot={false}
											setIsLoading={setIsLoading}
											isSendBackOrNot={false}
										/>
									);
								},
							};

							finalTableauSecteur.push(obj);
						});
						console.log('Tableau des secteur', tableauSecteur);
					}

					console.log(' kpi_amount ', kpi_amount);

					dispatch(updateKPI(kpi_amount));
					dispatch(updateTableauSecteur(finalTableauSecteur));
					dispatch(updateTableauGlobal(finalTableauGlobal));
					dispatch(
						updateTableauGlobalResilie(finalTableauGlobalResilie)
					);
				}
			})
			.catch(error => {
				dispatch(isDashboardLoading(false));
				ToastGeneric(`Erreur serveur.`, 'error', 3000).fire();
			});
	};

	/** line graph resiliation */
	const getDataLineGraphResiliation = (dataSend: TReportingBodyRequest) => {
		console.log('line chart resiliation dataSend ', dataSend);
		dispatch(isLineChartResiliationLoading(true));
		apiLineChartResilitation(dataSend)
			.then((response: any) => {
				dispatch(isLineChartResiliationLoading(false));

				if (response.error) {
					ToastGeneric(response.message, 'error', 3000).fire();
				} else {
					let lineGraphResiliation: TLineGraph | null =
						response.data as TLineGraph | null;

					dispatch(updateLineGraphResiliation(lineGraphResiliation));
				}
			})
			.catch(error => {
				dispatch(isLineChartResiliationLoading(false));
				ToastGeneric(`Erreur serveur.`, 'error', 3000).fire();
			});
	};

	/** line graph resiliation */
	const getDataLineGraphAbonnement = (dataSend: TReportingBodyRequest) => {
		dispatch(isLineChartAbonnementLoading(true));
		apiLineChartAbonnement(dataSend)
			.then((response: any) => {
				dispatch(isLineChartAbonnementLoading(false));
				if (response.error) {
					ToastGeneric(response.message, 'error', 3000).fire();
				} else {
					let lineGraphAbonnement: TLineGraph | null =
						response.data as TLineGraph | null;
					dispatch(updateLineGraphAbonnement(lineGraphAbonnement));
					// dispatch(isDashboardLoading(false));
				}
			})
			.catch(error => {
				dispatch(isLineChartAbonnementLoading(false));
				ToastGeneric(`Erreur serveur.`, 'error', 3000).fire();
			});
	};

	useEffect(() => {
		let dataToSend: TReportingBodyRequest = {
			date_debut: null,
			date_fin: null,
			debut_abon: null,
			fin_abon: null,
			perimetre: null,
			position: null,
		};

		getTableDataAndKPIAmount(dataToSend);
		// dispatch(isLineChartResiliationLoading(true));
		// dispatch(isLineChartAbonnementLoading(true));

		getDataLineGraphResiliation(dataToSend);
		getDataLineGraphAbonnement(dataToSend);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ExportProgressLoader isLoading={isLoading} />
			<form
				className="fs-filter-container-p"
				onSubmit={formik.handleSubmit}
			>
				<div className="fs-filter-container">
				<div className="select-container">
					<span>Périmètre</span>
					<FormControl className="filter-select" size="small">
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							name="perimetre_abonne"
							value={formik.values.perimetre_abonne}
							onChange={e => {
								console.log(e);

								formik.handleChange(e);
								setPerimetreSelected?.(
									e.target?.value.toLowerCase() !== 'all'
										? e.target?.value
										: ''
								);
							}}
						>
							<MenuItem value={'All'}> Tous </MenuItem>
							<MenuItem value={'HT'}> HT</MenuItem>
							<MenuItem value={'BT'}> BT</MenuItem>
						</Select>
					</FormControl>
				</div>
				<div className="select-container">
					<span>Position d'abonnement</span>
					<FormControl className="filter-select" size="small">
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							name="position_abonne"
							value={formik.values.position_abonne}
							onChange={e => {
								console.log(e);

								formik.handleChange(e);
								setPositionAbonnementSelected?.(
									e.target?.value.toLowerCase() !== 'all'
										? e.target?.value
										: ''
								);
							}}
						>
							<MenuItem value={'All'}> Tous </MenuItem>
							<MenuItem value={'Actif'}> Actif </MenuItem>
							<MenuItem value={'Résilié'}> Résilié </MenuItem>
						</Select>
					</FormControl>
				</div>
				<div className="date-picker-container">
					<span>Période d'abonnement</span>
					<div className="date-input-container">
						<div className="date-picker-start">
							<FormControl className="filter-select" size="small">
								{/* <InputLabel id="demo-simple-select-label">Ts</InputLabel> */}
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									name="periode_abonnement_trimestre_debut"
									value={
										formik.values
											.periode_abonnement_trimestre_debut
									}
									onChange={formik.handleChange}
								>
									<MenuItem value={'All'}> Tous </MenuItem>
									<MenuItem value={'T1'}> T1 </MenuItem>
									<MenuItem value={'T2'}> T2 </MenuItem>
									<MenuItem value={'T3'}> T3 </MenuItem>
									<MenuItem value={'T4'}> T4 </MenuItem>
								</Select>
							</FormControl>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									className="date-input"
									views={['year']}
									value={date_abonnement_debut}
									onChange={newValue => {
										setDate_abonnement_debut(newValue);
										formik.setFieldValue(
											'periode_abonnement_annee_debut',
											newValue?.get('year').toString()
										);
									}}
									minDate={dayjs(
										new Date(anneeMinAbonnement, 0)
									)}
									maxDate={dayjs(
										new Date(anneeMaxAbonnement, 11)
									)}
									renderInput={params => (
										<TextField
											size="small"
											{...params}
											helperText={null}
										/>
									)}
								/>
							</LocalizationProvider>
						</div>
						<div className="date-picker-start">
							<FormControl className="filter-select" size="small">
								{/* <InputLabel id="demo-simple-select-label">Ts</InputLabel> */}
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									name="periode_abonnement_trimestre_fin"
									value={
										formik.values
											.periode_abonnement_trimestre_fin
									}
									onChange={formik.handleChange}
								>
									<MenuItem value={'All'}> Tous </MenuItem>
									<MenuItem value={'T1'}> T1 </MenuItem>
									<MenuItem value={'T2'}> T2 </MenuItem>
									<MenuItem value={'T3'}> T3 </MenuItem>
									<MenuItem value={'T4'}> T4 </MenuItem>
								</Select>
							</FormControl>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									className="date-input"
									views={['year']}
									value={date_abonnement_fin}
									onChange={newValue => {
										setDate_abonnement_fin(dayjs(newValue));
										formik.setFieldValue(
											'periode_abonnement_annee_fin',
											dayjs(newValue)
												?.get('year')
												.toString()
										);
									}}
									minDate={dayjs(
										new Date(anneeMinAbonnement, 0)
									)}
									maxDate={dayjs(
										new Date(anneeMaxAbonnement, 11)
									)}
									renderInput={params => (
										<TextField
											size="small"
											{...params}
											helperText={null}
										/>
									)}
								/>
							</LocalizationProvider>
						</div>
					</div>
					{formik.errors.periode_abonnement_annee_fin && (
						<small className="helper-text">
							{' '}
							<InlineIcon icon="ci:error-outline" />{' '}
							{formik.errors.periode_abonnement_annee_fin}{' '}
						</small>
					)}
					{formik.errors.periode_abonnement_trimestre_fin && (
						<small className="helper-text">
							{' '}
							<InlineIcon icon="ci:error-outline" />{' '}
							{formik.errors.periode_abonnement_trimestre_fin}{' '}
						</small>
					)}
				</div>
				<div className="date-picker-container">
					<span>Période de résiliation</span>
					<div className="date-input-container">
						<div className="date-picker-start">
							<FormControl className="filter-select" size="small">
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									name="periode_resiliation_trimestre_debut"
									value={
										formik.values
											.periode_resiliation_trimestre_debut
									}
									onChange={formik.handleChange}
								>
									<MenuItem value={'All'}> Tous </MenuItem>
									<MenuItem value={'T1'}> T1 </MenuItem>
									<MenuItem value={'T2'}> T2 </MenuItem>
									<MenuItem value={'T3'}> T3 </MenuItem>
									<MenuItem value={'T4'}> T4 </MenuItem>
								</Select>
							</FormControl>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									className="date-input"
									views={['year']}
									value={date_resiliation_debut}
									onChange={newValue => {
										setDate_resiliation_debut(newValue);
										formik.setFieldValue(
											'periode_resiliation_annee_debut',
											newValue?.get('year').toString()
										);
									}}
									minDate={dayjs(
										new Date(anneeMinResiliation, 0)
									)}
									maxDate={dayjs(
										new Date(anneeMaxResiliation, 11)
									)}
									renderInput={params => (
										<TextField
											size="small"
											{...params}
											helperText={null}
										/>
									)}
								/>
							</LocalizationProvider>
						</div>
						<div className="date-picker-start">
							<FormControl className="filter-select" size="small">
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									name="periode_resiliation_trimestre_fin"
									value={
										formik.values
											.periode_resiliation_trimestre_fin
									}
									onChange={formik.handleChange}
								>
									<MenuItem value={'All'}> Tous </MenuItem>
									<MenuItem value={'T1'}> T1 </MenuItem>
									<MenuItem value={'T2'}> T2 </MenuItem>
									<MenuItem value={'T3'}> T3 </MenuItem>
									<MenuItem value={'T4'}> T4 </MenuItem>
								</Select>
							</FormControl>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									className="date-input"
									views={['year']}
									value={date_resiliation_fin}
									onChange={newValue => {
										setDate_resiliation_fin(newValue);
										formik.setFieldValue(
											'periode_resiliation_annee_fin',
											newValue?.get('year').toString()
										);
									}}
									minDate={dayjs(
										new Date(anneeMinResiliation, 0)
									)}
									maxDate={dayjs(
										new Date(anneeMaxResiliation, 11)
									)}
									renderInput={params => (
										<TextField
											size="small"
											{...params}
											helperText={null}
										/>
									)}
								/>
							</LocalizationProvider>
						</div>
					</div>
					{formik.errors.periode_resiliation_annee_fin && (
						<small className="helper-text">
							{' '}
							<InlineIcon icon="ci:error-outline" />{' '}
							{formik.errors.periode_resiliation_annee_fin}{' '}
						</small>
					)}
					{formik.errors.periode_resiliation_trimestre_fin && (
						<small className="helper-text">
							{' '}
							<InlineIcon icon="ci:error-outline" />{' '}
							{formik.errors.periode_resiliation_trimestre_fin}{' '}
						</small>
					)}
				</div>
				</div>
  
	<div style={{display: 'flex', justifyContent: 'center', 'gap': '10px','padding': '10px'}}>
				<Button
					className="filter-button ok"
					variant="contained"
					type="submit"
					disabled={!formik.isValid}
					startIcon={<Icon icon="bxs:filter-alt" />}
				>
					Filtrer
				</Button>

				<Button
					className="filter-button cancel-button"
					variant="contained"
					type="button"
					onClick={cancelSearch}
					startIcon={<Icon icon="ep:circle-close" />}
				>
					Annuler
				</Button>
				</div>
			</form>
		</>
	);
};

const mapStateToProps = createStructuredSelector({
	kpiDatas: selectDashboardKPI,
});

const connector = connect(mapStateToProps);

export default connector(DashboardFilter);
